import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import InfoIcon from '@mui/icons-material/Info';

type TSubmissionCountdownTimerProps = {
  value: number;
  run: boolean;
  showInfoIcon: boolean;
  isTimeUpAlertVisible: boolean;
  showTimeUpAlert?: () => void;
};

const SubmissionCountdownTimer: React.FC<TSubmissionCountdownTimerProps> = ({
  value,
  run,
  showInfoIcon,
  isTimeUpAlertVisible,
  showTimeUpAlert,
}) => {
  // State
  const [seconds, setSeconds] = useState(0);
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | undefined>(
    undefined
  );

  useEffect(() => {
    setSeconds(value);

    if (run) {
      const interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);

      setIntervalId(interval);
    }

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!run) {
      clearInterval(intervalId);
      setSeconds(value);
    }
  }, [run]);

  useEffect(() => {
    if (seconds < 0 && !isTimeUpAlertVisible && showTimeUpAlert) {
      showTimeUpAlert();
    }
  }, [seconds]);

  const absoluteSeconds = Math.abs(seconds);

  let mins = 0;
  let secs = 0;
  let textColor = '#01A79F';

  mins = Math.floor(absoluteSeconds / 60);
  secs = Math.floor(absoluteSeconds % 60);

  if (seconds < 1) {
    textColor = '#FF5630';
  }

  return (
    <Typography
      display="flex"
      alignItems="center"
      textAlign="center"
      fontWeight={500}
      fontSize="16px"
      color={textColor}
    >
      <AccessAlarmIcon style={{ color: textColor }} />
      &nbsp; {mins} min {secs} sec
      {showInfoIcon ? (
        <>
          &nbsp;
          <InfoIcon fontSize="small" style={{ color: textColor }} />
        </>
      ) : null}
    </Typography>
  );
};

export default SubmissionCountdownTimer;
